import { createContainer, createHook, createStateHook, createStore, defaults } from 'react-sweet-state';

// jira freezes the global defaults object
if (!Object.isFrozen(defaults)) {
  defaults.devtools = process.env.NODE_ENV === 'development' && !process.env.CI;
}
import { generateFilterStateKey } from '@atlassian/notification-common';
import { ReadState } from '@atlassian/notification-common/types';
import { getFilterStateOrDefaultByKey } from '../../utils/build-filter-state';
import actions from './actions';
import selectFilteredNotifications, { isGroupsMarkAllAsReadVisible } from './selectors';
var Store = createStore({
  initialState: {
    ids: [],
    notifications: {},
    filterStates: {},
    groups: []
  },
  actions: actions,
  name: 'notifications'
});
var StoreContainer = createContainer(Store, {
  onInit: function onInit() {
    return function (_ref, state) {
      var setState = _ref.setState;
      setState(state);
    };
  }
});
var useNotifications = createHook(Store);
var useNotificationActions = createHook(Store, {
  selector: null
});

// filter the notifications based on the selected filters
var useFilteredNotifications = createHook(Store, {
  selector: selectFilteredNotifications
});
var useIsMarkAllAsReadVisible = createHook(Store, {
  selector: function selector(state, args) {
    return selectFilteredNotifications(state, args).some(function (notification) {
      return notification.readState === ReadState.UNREAD;
    });
  }
});
var useIsGroupsMarkAllAsReadVisible = createStateHook(Store, {
  selector: isGroupsMarkAllAsReadVisible
});
var useNotificationsLoadingState = createHook(Store, {
  selector: function selector(state, filters) {
    return getFilterStateOrDefaultByKey(state.filterStates, generateFilterStateKey(filters));
  }
});
export var useNotificationGroups = createHook(Store, {
  selector: function selector(state) {
    return state.groups;
  }
});
export { StoreContainer, useNotifications, useNotificationActions, useIsMarkAllAsReadVisible, useFilteredNotifications, useNotificationsLoadingState, useIsGroupsMarkAllAsReadVisible };